import { Box, Tag, Text } from '@nimbus-ds/components';
import { Page } from '@nimbus-ds/patterns';
import {
  InformationForContentDeclarationResponseDto,
  InformationForDocumentResponseDto,
} from '@tiendanube/common';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';

interface PrintLabelHeaderProps {
  information:
    | InformationForContentDeclarationResponseDto[]
    | InformationForDocumentResponseDto[]
    | undefined;
}

function PrintLabelHeader({ information }: Readonly<PrintLabelHeaderProps>) {
  const t = useNuvemEnvioTranslations();

  const orderNumbers = Boolean(information?.length);

  return (
    <Page.Header
      id="NuvemEnvioAsyncLabelGenerateStatusPageHeader"
      title={t('printNuvemEnvioLabelsStatus.asyncPage.title')}
    >
      <Box display="flex" gap="2">
        {!orderNumbers ? (
          <Tag.Skeleton width="55px" height="20px" />
        ) : information?.length === 1 ? (
          <Tag key={information?.[0]?.order?.id}>
            #{information?.[0]?.order?.number}
          </Tag>
        ) : (
          <Text>
            {information?.length}{' '}
            {t('printNuvemEnvioLabelsStatus.asyncPage.selectedOrders')}
          </Text>
        )}
      </Box>
    </Page.Header>
  );
}

export default PrintLabelHeader;
